import React from 'react'
import { createPortal } from 'react-dom'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import { useDispatch } from 'react-redux'

const Alert = React.forwardRef(function Alert(props, ref) {
    return (
        <MuiAlert
            ref={ref}
            elevation={0}
            variant="filled"
            {...props}
        />
    )
})

const normalizeSeverity = (color) => {
    if (color === 'danger') return 'error'
    if (color === 'error') return 'error'
    if (color === 'warning') return 'warning'
    if (color === 'info') return 'info'
    return 'success'
}

const AlertComponent = ({
    color,
    text,
    showObj,
    dispatchCloseAlert
}) => {
    const dispatch = useDispatch()

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }

        if (typeof dispatchCloseAlert === 'function') {
            dispatch(dispatchCloseAlert())
        }
    }

    if (!showObj || !text) {
        return null
    }

    const content = (
        <Snackbar
            className="siteAlertSnackbar"
            open={Boolean(showObj)}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
        >
            <Alert
                className="siteAlert"
                onClose={handleClose}
                severity={normalizeSeverity(color)}
            >
                {text}
            </Alert>
        </Snackbar>
    )

    if (typeof document === 'undefined') {
        return content
    }

    return createPortal(content, document.body)
}

export default AlertComponent